import { SUB_MATCH_DATE_DIFF, TournamentSubMatchSettings } from '@okletsplay/core';
import { isNull } from 'lodash';
import moment from 'moment/moment';
import { addMethod, object } from 'yup';

addMethod(object, 'matchDate', function (message: string) {
  return this.test('matchDate', function (value) {
    if (!value?.round) {
      return true;
    }

    if (isNull(value?.startedAt)) {
      return true;
    }

    const previousSubMatches = this.parent
      .filter(
        (subMatch: TournamentSubMatchSettings) =>
          subMatch?.round <= value?.round - 1 && subMatch?.startedAt
      )
      .map((subMatch: TournamentSubMatchSettings) => subMatch);

    const previousSubMatch = previousSubMatches[previousSubMatches.length - 1];

    if (!previousSubMatch?.startedAt) {
      return false;
    }

    const currentDate = moment(value.startedAt);
    const previousDate = moment(previousSubMatch.startedAt);

    if (!currentDate.isValid()) {
      throw this.createError({ path: `${this.path}.startedAt`, message: message });
    }

    const dateDiff = currentDate.diff(previousDate, 'seconds');

    if (dateDiff < SUB_MATCH_DATE_DIFF || isNaN(dateDiff)) {
      throw this.createError({ path: `${this.path}.startedAt`, message: message });
    }

    return true;
  });
});
